module.exports = __webpack_public_path__ + "static/media/find-contacts-correct.df12d7c1.png";